const config = {
  development: {
    // API_URL: 'https://prod-xtram-alb-1095095078.il-central-1.elb.amazonaws.com/api',
    // API_URL: 'https://prod-xtram-alb-1095095078.il-central-1.elb.amazonaws.com/api',
    API_URL: 'http://localhost:5163/api',
    CHAT_URL: 'https://chat.xtram.co.il',
    FRONTEND_URL: 'http://localhost:3000',
    // CHAT_URL: 'http://localhost:5036',
  },
  production: {
    API_URL: 'https://server.am.xtram.co.il/api',
    // API_URL: 'https://prod-xtram-alb-1095095078.il-central-1.elb.amazonaws.com/api',
    // API_URL: 'https://accounting-manager.com:5163/api',
    CHAT_URL: 'https://chat.xtram.co.il',
    FRONTEND_URL: 'https://am.xtram.co.il',
    // CHAT_URL: 'http://localhost:5036',
  },
  staging: {
    // API_URL: 'https://staging-xtram-alb-446906538.il-central-1.elb.amazonaws.com/api',
    API_URL: 'https://staging-server.am.xtram.co.il/api',
    CHAT_URL: 'https://chat.xtram.co.il',
    FRONTEND_URL: 'https://staging.am.xtram.co.il',
    // CHAT_URL: 'http://localhost:5036',
  },
};

export default config;